import { render } from "./base-permission-icon.vue?vue&type=template&id=1a529f4e&ts=true"
import script from "./base-permission-icon.vue?vue&type=script&lang=ts"
export * from "./base-permission-icon.vue?vue&type=script&lang=ts"

import "./base-permission-icon.vue?vue&type=style&index=0&id=1a529f4e&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__